import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Kaggle コンペティション・ソリューション検索</h3>
          <p>過去のKaggleコンペティションとソリューションを簡単に検索できるツールです。</p>
        </div>
        
        <div className="footer-section">
          <h3>機能</h3>
          <ul>
            <li>コンペティション検索</li>
            <li>ソリューション検索</li>
            <li>類似コンペの検索</li>
            <li>高度なフィルタリング</li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>お問い合わせ</h3>
          <p>ご質問やフィードバックがありましたら、お気軽にご連絡ください。</p>
          <a href="mailto:contact@kaggle-search.example.com">contact@kaggle-search.example.com</a>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>© 2025 Kaggle Search App. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
